import React, { useState, useEffect } from "react";

import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import { useSelector } from "react-redux";
import moment from "moment";
import { Spin, Tooltip } from "antd";
import Chart from "react-google-charts";

const DiamondReportsClicksComp = ({
  globalDiamonds,
  isApplyFilter,
  mainForDealer,
}) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const loginDetials = useSelector((state) => state.loginReducer);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [diamondClicksLabels, setdiamondClicksLabels] = useState([]);
  const [DiamondClicksYAxisList, setDiamondClicksYAxisList] = useState([]);
  const [key, setKey] = useState(true);

  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          handleLoadExtendedDiamondChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  /*API Binding Starts*/

  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: "0",
        forDealer: "3",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);

      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondClicksList = responseData.DiamondClicks;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              var DiamondClicksLabelArr = DiamondClicksList.map((item) => {
                return item.Date;
              });
              setdiamondClicksLabels(DiamondClicksLabelArr);
              var DiamondClicksYAxisList = DiamondClicksList.map((item) => {
                return item.CNT;
              });
              setDiamondClicksYAxisList(DiamondClicksYAxisList);
              setKey(!key);
            }
          } else {
            setDiamondClicksYAxisList([]);
          }
        })
        .catch((error) => {
          setDiamondClicksYAxisList([]);
          setLoadChartReportsLoading(false);
          setdiamondClicksLabels([]);
        });
    } catch (error) {
      setDiamondClicksYAxisList([]);
      setLoadChartReportsLoading(false);
      setdiamondClicksLabels([]);
    }
  };
  /*API Binding Ends*/

  const chartData = [
    ["Label", "Clicks"],
    ...diamondClicksLabels?.map((label, index) => [
      label,
      DiamondClicksYAxisList[index],
    ]),
  ];

  const options = {
    curveType: "function",
    legend: { position: "none" },
    chartArea: {
      width: "90%",
      height: "60%",
    },
    hAxis: {
      title: "Date",
      textStyle: {
        color: "#424242",
        fontSize: 8,
      },
      slantedText: true, // Slant the text
      slantedTextAngle: 45, // Angle of slant (30-60 works well)
      showTextEvery: diamondClicksLabels.length > 15 ? 2 : 1,
    },
    vAxis: {
      title: "Clicks",
      minValue: 0,
      viewWindow: {
        min: 0,
        max: Math.max(...DiamondClicksYAxisList) + 10 || 10,
      },
    },
    lineWidth: 2,
    colors: ["rgb(66, 133, 244)"],
    tooltip: { trigger: "focus" },
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b> {t("Diamond Clicks")} </b>
        </label>
        <div className="chart__section">
          <Spin spinning={LoadChartReportsLoading} size="large">
            {/* <Line
              key={key}
              data={{
                labels: diamondClicksLabels,
                datasets: [
                  {
                    label: "Clicks",
                    data: DiamondClicksYAxisList,
                    fill: false,
                    borderColor: "rgb(66, 133, 244)",
                    borderWidth: 1,
                  },
                ],
              }}
              width={300}
              height={300}
              options={{
                scales: {
                  x: {
                    title: {
                      color: "rgb(66, 66, 66)",
                      display: false,
                      text: "Certificate",
                      font: {
                        size: 16,
                      },
                    },
                  },
                },
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  datalabels: {
                    display: false,
                  },
                  legend: {
                    display: false,
                  },
                },
              }}
            /> */}
            <div>
              {diamondClicksLabels.length > 0 && (
                <Chart
                  chartType="AreaChart"
                  data={chartData}
                  options={options}
                  width="100%"
                  height="300px"
                />
              )}
              {!LoadChartReportsLoading && diamondClicksLabels.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                  {t("No data available")}
                </div>
              )}
            </div>
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsClicksComp;
